// AnalyticsDashboard.jsx
import './AnalyticsDashboard.css';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
  Tabs,
  Tab,
  Popover
} from '@mui/material';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import messenger_ico from '../../../assets/traffic_monster/messenger.svg';
import dollar_ico from '../../../assets/traffic_monster/dollar.svg';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import textFileIcon from '../../../assets/traffic_monster/text_file.svg';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import { useEffect, useState } from 'react';
import { isMobile } from "react-device-detect";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { getCookie } from "utils/storageUtils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import axios from 'axios';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useCallback, useRef } from 'react';

const border = "#636363";
const interFont = "'Inter', sans-serif";

const timeTabs = [
  { label: "7 Days", value: "7days" },
  { label: "30 Days", value: "30days" },
  { label: "90 Days", value: "90days" },
  { label: "1 Year", value: "1year" },
];

// ─────────────────────────────────────────────
// DUMMY DATA — shown when real data is empty
// ─────────────────────────────────────────────
const DUMMY_DATA = {
  paid_learners: 0,
  total_learners: 0,
  total_courses: 18,
  digital_twins: 5,
  total_episodes: 97,
  total_blogs: 43,
  total_audios: 22,
  total_documents: 11,
  total_clips: 35,
  total_images: 214,
  dashboard: {
    revenue: { total: "24,500", change_percent: 18 },
    learners: { change_percent: 12 },
  },
  charts: {
    paid_learners_chart: {
      labels: ["Apr 1", "Apr 2", "Apr 3", "Apr 4", "Apr 5", "Apr 6", "Apr 7"],
      data: [30, 52, 45, 80, 95, 110, 128],
    },
    revenue_chart: {
      labels: ["Apr 1", "Apr 2", "Apr 3", "Apr 4", "Apr 5", "Apr 6", "Apr 7"],
      data: [3200, 5400, 4100, 8900, 11200, 19800, 24500],
    },
    learners_chart: {
      labels: ["Apr 1", "Apr 2", "Apr 3", "Apr 4", "Apr 5", "Apr 6", "Apr 7"],
      data: [80, 120, 155, 210, 270, 310, 342],
    },
  },
};

// Helper: check if chart data is empty (the key visual that looks broken)
function isChartDataEmpty(data: any): boolean {
  if (!data) return true;
  const learnersChart = data?.charts?.paid_learners_chart?.data ?? [];
  const revenueChart = data?.charts?.revenue_chart?.data ?? [];
  const totalLearnersChart = data?.charts?.learners_chart?.data ?? [];
  const allCharts = [...learnersChart, ...revenueChart, ...totalLearnersChart];
  return allCharts.length === 0 || allCharts.every((v: any) => Number(v) === 0);
}

interface FollowCounts {
  followers_count: number;
  following_count: number;
}

export default function AnalyticsDashboard() {

  const [value, setValue] = useState(0);
  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [userDets, setUserDets] = useState<any>();
  const [MRCount, setMRCount] = useState<any>();
  const [followCounts, setFollowCounts] = useState<FollowCounts>({
    followers_count: 0,
    following_count: 0,
  });
  const [stats, setStats] = useState({ total: 0, published: 0, pending: 0 });
  const [filter, setFilter] = useState("7days");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [showingDummy, setShowingDummy] = useState(true);
  const [showingDummy, setShowingDummy] = useState(() => {
    const isCleared = localStorage.getItem("mockDataCleared") === "true";
    return !isCleared; /* (if cleared, it will don't show dummy) */
  });

  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().subtract(6, "day"));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  const hasFetched = useRef(false);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const useremail = localStorage.getItem("user_email") || "";

  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: useremail || getCookie("user_email") || "",
        filter: filter ? filter : "",
        start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
        end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
      });
      if ("data" in response) {
        const realData = response.data.data;
        setUserDets(realData);
        getEnquires(realData?._id/* '674ba8a8335824d2b2d3fed8' */);

        const isCleared = localStorage.getItem("mockDataCleared") === "true";
        if (!isCleared) {
          if (isChartDataEmpty(realData)) {
            setShowingDummy(true);
          } else {
            setShowingDummy(false);
          }
        } else {
          setShowingDummy(false);
        }
        console.log("analytics dashboard res=>", realData);
      }
    } catch (error) { }
  };

  const getEnquires = async (id: any) => {
    try {
      const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
      const res = await axios.get(`${apiUrl}/api/auth/enquiries/${id}`);
      // console.log('enquires data =>', res?.data?.data.length);
      const val = res.data?.data;
      setMRCount(val?.length);
    } catch (error: any) {
      console.log('Error fetching message received count=>', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filter, startDate, endDate]);

  const displayData = showingDummy ? DUMMY_DATA : userDets;

  const topCards = [
    {
      title: 'Page Views',
      value: '0',
      subtitle: 'All pages',
      growth: userDets?.growth?.page_views ?? 0/* (userDets?.growth?.page_views === null ? 0 : userDets?.growth?.page_views) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}`/* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      color: '#014D4E',
      icon: <VisibilityIcon />,
    },
    {
      title: 'Leads Captured',
      value: followCounts.followers_count || 0,
      subtitle: 'New leads',
      growth: userDets?.growth?.leads ?? 0/* (userDets?.growth?.leads === null ? 0 : userDets?.growth?.leads) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}`/* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      color: '#800080',
      icon: <PeopleAltIcon />,
    },
    {
      title: 'Messages Received',
      value: MRCount ? MRCount : 0,
      subtitle: 'New conversations',
      growth: userDets?.growth?.messages ?? 0/* (userDets?.growth?.messages === null ? 0 : userDets?.growth?.messages) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}`/* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      color: '#0000FF',
      icon: <img src={messenger_ico} alt="messenger" />,
    },
    {
      title: 'Revenue Generated',
      value: userDets?.dashboard?.revenue?.total ? userDets?.dashboard?.revenue?.total : 0,
      subtitle: 'From courses',
      growth: userDets?.growth?.revenue ?? 0/* (userDets?.growth?.revenue === null ? 0 : userDets?.growth?.revenue) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}`/* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      color: '#089000',
      icon: <img src={dollar_ico} alt="dollar" />,
    },
  ];

  const contentCards = [
    {
      title: 'Blogs Published',
      value: userDets?.total_blogs || 0,
      growth: userDets?.growth?.blogs ?? 0/* (userDets?.growth?.blogs === null ? 0 : userDets?.growth?.blogs) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}` /* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      icon: <img src={textFileIcon} alt="text-file" />,
      color: '#99FFFF',
    },
    {
      title: 'Episodes Uploaded',
      value: userDets?.total_episodes || 0,
      growth: userDets?.growth?.episodes ?? 0/* (userDets?.growth?.episodes === null ? 0 : userDets?.growth?.episodes) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}` /* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      icon: <SmartDisplayIcon />,
      color: '#36013F',
    },
    {
      title: 'Clips Created',
      value: userDets?.total_clips || 0,
      growth: userDets?.growth?.clips ?? 0/* (userDets?.growth?.clips === null ? 0 : userDets?.growth?.clips) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}` /* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      icon: <ContentCutIcon />,
      color: '#FF0000',
    },
    {
      title: 'Images Created',
      value: userDets?.total_images || 0,
      growth: userDets?.growth?.images ?? 0/* (userDets?.growth?.images === null ? 0 : userDets?.growth?.images) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}` /* ` vs ${userDets?.period?.label?.split(' ')[0] + ' ' + userDets?.period?.filter}` */,
      icon: <ImageOutlinedIcon />,
      color: '#4ADE80',
    },
    {
      title: 'Social Posts Published',
      value: stats?.published || 0,
      growth: userDets?.growth?.social_posts ?? 0/* (userDets?.growth?.social_posts === null ? 0 : userDets?.growth?.social_posts) */,
      vs: `vs ${userDets?.period?.label?.split(" ")?.[0] || ""
        } ${userDets?.period?.filter || ""}`/* userDets?.period?.label?.split(' ')[0] + userDets?.period?.filter */,
      icon: <CampaignOutlinedIcon />,
      color: '#9B7A01',
    },
  ];

  const chartLine = (color: any) => (
    <svg width="90" height="40" viewBox="0 0 90 40" fill="none">
      <path
        d="M3 32C10 31 15 12 24 18C31 22 36 36 45 30C52 26 55 10 63 13C72 16 75 30 87 6"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <defs>
        <filter id={`glow-${color}`}>
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );

  const API_BASE_URL = process.env.REACT_APP_SERVER_ENDPOINT || "";
  const user_id = localStorage.getItem("userid");

  useEffect(() => {
    if (!user_id || hasFetched.current) return;

    hasFetched.current = true;

    const fetchFollowCounts = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/auth/follow-counts`,
          { user_id },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data) {
          setFollowCounts({
            followers_count: response.data.followers_count ?? 0,
            following_count: response.data.following_count ?? 0,
          });
        }
      } catch (error) {
        console.error("FollowCounts ERROR =>", error);
      }
    };

    fetchFollowCounts();
  }, [user_id]);



  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;

    const fetchStats = async () => {
      try {
        const userEmail = localStorage.getItem("user_email") || "";
        const { data } = await axios.get(`${API_BASE_URL}/api/socialmedia/api/posts/stats`, {
          params: { user_email: userEmail },
          withCredentials: true,
        });
        setStats({ total: data.total, published: data.published, pending: data.pending });
      } catch (err) { console.error("Failed to fetch stats", err); }
    };

    fetchStats();
  }, []);

  const paidUsers = Number(displayData?.paid_learners ?? 0);
  const freeUsers = Number(0);

  const totalUsers = paidUsers + freeUsers;

  const paidPercentage =
    totalUsers > 0 ? ((paidUsers / totalUsers) * 100).toFixed(0) : 0;

  const freePercentage =
    totalUsers > 0 ? ((freeUsers / totalUsers) * 100).toFixed(0) : 0;

  const paidGradientEnd = Number(paidPercentage);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        // bgcolor: '#030712',
        /*  background:
           'radial-gradient(circle at top left, rgba(0,153,255,0.12), transparent 30%), #030712', */
        // p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          maxWidth: '1450px',
          mx: 'auto',
          color: '#fff',
        }}
      >
        {/* Header */}
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          justifyContent="space-between"
          spacing={2}
          alignItems={{ xs: 'flex-start', lg: 'center' }}
          mb={4}
        >
          <Box>
            <Typography
              sx={{
                fontSize: { xs: '28px', md: '34px' },
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              Analytics
            </Typography>
            <Typography
              sx={{
                color: '#D9D9D9',
                fontSize: '14px',
              }}
            >
              Track your growth, audience and revenue.
            </Typography>
          </Box>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            width={{ xs: '100%', lg: 'auto' }}
          >
            <Box
              sx={{
                background: "#2a2c36",
                borderRadius: "8px",
                p: "4px",
                display: "block",
                maxWidth: "100%",
              }}
            >
              <Tabs
                value={value}
                onChange={(_, newValue) => {
                  setValue(newValue);
                  setFilter(timeTabs[newValue].value);
                }}
                TabIndicatorProps={{ style: { display: "none" } }}
                variant="scrollable"
                scrollButtons={false}
                sx={{
                  minHeight: "unset",
                  maxWidth: "100%",
                  "& .MuiTabs-scroller": { overflowX: "auto" },
                  "& .MuiTabs-flexContainer": { gap: "4px", flexWrap: "nowrap" },
                }}
              >
                {timeTabs.map((t) => (
                  <Tab
                    key={t.label}
                    label={t.label}
                    disableRipple
                    sx={{
                      minHeight: "30px",
                      textTransform: "none",
                      fontFamily: interFont,
                      fontSize: 13,
                      color: "#7A7A7A",
                      borderRadius: "8px",
                      px: 1.5,
                      py: 0.5,
                      "&.Mui-selected": {
                        // background: "#0f1016",
                        background: '#4BA5EB',
                        border: `1px solid ${border}`,
                        color: "#fff",
                      },
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Button
                size="small"
                startIcon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
                onClick={handleClick}
                sx={{
                  textTransform: "none",
                  fontFamily: interFont,
                  fontSize: 12,
                  color: "#fff",
                  // background: "#15151D",
                  background: 'transparent',
                  borderRadius: "6px",
                  px: 1.5,
                  border: `1px solid ${border}`,
                  whiteSpace: "nowrap",
                }}
              >
                {startDate?.format("DD MMM")} – {endDate?.format("DD MMM, YYYY")}
              </Button>

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Box sx={{ p: 2, display: "flex", gap: 2 }}>
                  <DatePicker
                    label="From"
                    value={startDate}
                    onChange={(newValue) => setStartDate(newValue)}
                  />
                  <DatePicker
                    label="To"
                    value={endDate}
                    minDate={startDate || undefined}
                    onChange={(newValue) => setEndDate(newValue)}
                  />
                </Box>
              </Popover>
            </LocalizationProvider>
          </Stack>
        </Stack>

        {/* Growth Overview */}
        <Box mb={5}>
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <RocketLaunchOutlinedIcon sx={{ fontSize: '22px', color: '#4BA5EB' }} />
            <Typography fontWeight={500} fontSize="18px">
              Growth Overview
            </Typography>
          </Stack>

          <Typography color="#D9D9D9" fontSize="13px" mb={2.5}>
            Your key performance metrics for the selected time period.
          </Typography>

          <Grid container spacing={2}>
            {topCards.map((card) => (
              <Grid item xs={12} sm={6} lg={3} key={card.title}>
                <Card
                  sx={{
                    // bgcolor: 'rgba(10,16,30,0.95)',
                    background: 'rgba(255,255,255,0.06)',
                    // background: 'transparent',
                    // border: '1px solid rgba(255,255,255,0.06)',
                    border: '1px solid #rgba(255,255,255,0.06)',
                    borderRadius: '10px',
                    color: '#fff',
                    height: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    backdropFilter: 'blur(14px)',
                  }}
                >
                  <CardContent sx={{ p: 2.5 }}>
                    {/* Top Content Full Width */}
                    <Stack direction="row" spacing={1.2} alignItems="center" mb={2}>
                      <Box
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: '50px',
                          bgcolor: `${card.color}`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '18px',
                        }}
                      >
                        {card.icon}
                      </Box>

                      <Box>
                        <Typography fontSize="14px" fontWeight={600}>
                          {card.title}
                        </Typography>

                        <Typography color="#D9D9D9" fontSize="12px">
                          {card.subtitle}
                        </Typography>
                      </Box>
                    </Stack>

                    {/* Value Full Width */}
                    <Typography
                      sx={{
                        fontSize: { xs: '32px', md: '38px' },
                        fontWeight: 700,
                        lineHeight: 1,
                        mb: 2,
                      }}
                    >
                      {card.value}
                    </Typography>

                    {/* Only Bottom Row Split */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: 600,
                        }}
                      >
                        <Box component="span" sx={{ color: card.growth >= 0 ? '#4ADE80' : '#FF0000' }}>
                          {card.growth}%
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          {card.vs}
                        </Box>
                      </Typography>

                      {/* <Box>{chartLine(card.color)}</Box> */}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Audience & Course Performance */}
        <Box mb={5}>
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <PeopleAltOutlinedIcon sx={{ fontSize: '22px', color: '#4BA5EB' }} />
            <Typography fontWeight={700} fontSize="18px">
              Audience & Course Performance
            </Typography>
          </Stack>

          <Typography color="#D9D9D9" fontSize="13px" mb={2.5}>
            See how your audience is growing and engaging with your courses.
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} lg={5}>
              <Card
                sx={{
                  bgcolor: 'rgba(10,16,30,0.95)',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '20px',
                  color: '#fff',
                  height: '100%',
                }}
              >
                <CardContent sx={{ p: 2.5 }}>
                  <Stack direction="row" spacing={1.2} alignItems="center" mb={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50px',
                        bgcolor: '#800080',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                      }}
                    >
                      <SchoolIcon />
                    </Box>

                    <Box>
                      <Typography fontSize="14px" fontWeight={600}>
                        Total Course Enrollments
                      </Typography>
                      <Typography color="#7B849B" fontSize="12px">
                        All courses
                      </Typography>
                    </Box>
                  </Stack>

                  {/* <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={3}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: '42px',
                          fontWeight: 700,
                          lineHeight: 1,
                          mb: 2,
                        }}
                      >
                        148
                      </Typography>

                      <Typography fontSize="12px" fontWeight={600}>
                        <Box component="span" sx={{ color: '#4ADE80' }}>
                          + 22%
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          vs previous 7 days
                        </Box>
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        width: 150,
                        height: 150,
                        borderRadius: '50%',
                        background:
                          'conic-gradient(#A855F7 0% 42%, #3B82F6 42% 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                      }}
                    >
                      <Box
                        sx={{
                          width: 92,
                          height: 92,
                          borderRadius: '50%',
                          bgcolor: '#09111F',
                        }}
                      />
                    </Box>
                  </Stack>

                  <Stack direction="row" spacing={3} mt={2}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: '#A855F7',
                        }}
                      />
                      <Typography fontSize="12px" color="#B7C0D1">
                        Paid 62 (42%)
                      </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          bgcolor: '#3B82F6',
                        }}
                      />
                      <Typography fontSize="12px" color="#B7C0D1">
                        Free 86 (58%)
                      </Typography>
                    </Stack>
                  </Stack> */}
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={3}
                  >
                    {/* Left Content */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: '42px',
                          fontWeight: 700,
                          lineHeight: 1,
                          mb: 2,
                        }}
                      >
                        {/* 148 */}{paidUsers}
                      </Typography>

                      <Typography fontSize="12px" fontWeight={600}>
                        <Box component="span" sx={{ color: userDets?.growth?.enrollments >= 0 ? '#4ADE80' : '#FF0000' }}>
                          {/* {`${userDets?.growth?.enrollments !== null ? userDets?.growth?.enrollments : 0}%`} */}
                          {`${userDets?.growth?.enrollments ?? 0}%`}
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          {/* {` vs ${userDets?.period?.label.split(' ')[0] + ' ' + userDets?.period?.filter}`} */}
                          {`vs ${userDets?.period?.label?.split(" ")?.[0] || ""
                            } ${userDets?.period?.filter || ""}`}
                        </Box>
                      </Typography>
                    </Box>

                    {/* Chart + Labels */}
                    <Stack direction="row" spacing={2} alignItems="center">

                      {/* Circular Chart */}
                      <Box
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: '50%',
                          /* background:
                            'conic-gradient(#A855F7 0% 42%, #3B82F6 42% 100%)', */
                          background: `conic-gradient(
                                    #A855F7 0% ${paidGradientEnd}%,
                                    #3B82F6 ${paidGradientEnd}% 100%
                                  )`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          position: 'relative',
                        }}
                      >
                        <Box
                          sx={{
                            width: 92,
                            height: 92,
                            borderRadius: '50%',
                            bgcolor: '#09111F',
                          }}
                        />
                      </Box>

                      {/* Labels beside chart */}
                      <Stack spacing={2}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: '50%',
                              bgcolor: '#A855F7',
                            }}
                          />

                          <Typography fontSize="12px" color="#B7C0D1">
                            Paid {paidUsers} ({paidPercentage}%)
                          </Typography>
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center">
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: '50%',
                              bgcolor: '#3B82F6',
                            }}
                          />

                          <Typography fontSize="12px" color="#B7C0D1">
                            Free {freeUsers} ({freePercentage}%)
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} lg={3.5}>
              <Card
                sx={{
                  bgcolor: 'rgba(10,16,30,0.95)',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '20px',
                  color: '#fff',
                  height: '100%',
                }}
              >
                <CardContent sx={{ p: 2.5 }}>
                  <Stack direction="row" spacing={1.2} alignItems="center" mb={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50px',
                        bgcolor: '#0000FF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                      }}
                    >
                      <PersonIcon />
                    </Box>

                    <Box>
                      <Typography fontSize="14px" fontWeight={600}>
                        Paid Users
                      </Typography>
                      <Typography color="#7B849B" fontSize="12px">
                        Enrolled in paid courses
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                    <Box>
                      <Typography fontSize="42px" fontWeight={700} lineHeight={1} mb={2}>
                        {String(displayData?.paid_learners ?? 0)}
                      </Typography>

                      <Typography fontSize="12px" fontWeight={600}>
                        <Box component="span" sx={{ color: userDets?.growth?.paid_users >= 0 ? '#4ADE80' : '#FF0000' }}>
                          {/* {`${userDets?.growth?.paid_users !== null ? userDets?.growth?.paid_users : 0}%`} */} {`${userDets?.growth?.paid_users ?? 0}%`}
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          {/* {` vs ${userDets?.period?.label.split(' ')[0] + ' ' + userDets?.period?.filter}`} */}
                          {`vs ${userDets?.period?.label?.split(" ")?.[0] || ""
                            } ${userDets?.period?.filter || ""}`}
                        </Box>
                      </Typography>
                    </Box>

                    {/* {chartLine('#4F7CFF')} */}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} lg={3.5}>
              <Card
                sx={{
                  bgcolor: 'rgba(10,16,30,0.95)',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: '20px',
                  color: '#fff',
                  height: '100%',
                }}
              >
                <CardContent sx={{ p: 2.5 }}>
                  <Stack direction="row" spacing={1.2} alignItems="center" mb={2}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50px',
                        bgcolor: '#00555A',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                      }}
                    >
                      <PersonIcon />
                    </Box>

                    <Box>
                      <Typography fontSize="14px" fontWeight={600}>
                        Free Users
                      </Typography>
                      <Typography color="#7B849B" fontSize="12px">
                        Enrolled in free courses
                      </Typography>
                    </Box>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                    <Box>
                      <Typography fontSize="42px" fontWeight={700} lineHeight={1} mb={2}>
                        0
                      </Typography>

                      <Typography fontSize="12px" fontWeight={600}>
                        <Box component="span" sx={{ color: userDets?.growth?.free_users >= 0 ? '#4ADE80' : '#FF0000' }}>
                          {/* {`${userDets?.growth?.free_users !== null ? userDets?.growth?.free_users : 0}%`} */}
                          {`${userDets?.growth?.free_users ?? 0}%`}
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          {/* {` vs ${userDets?.period?.label.split(' ')[0] + ' ' + userDets?.period?.filter}`} */}
                          {`vs ${userDets?.period?.label?.split(" ")?.[0] || ""
                            } ${userDets?.period?.filter || ""}`}
                        </Box>
                      </Typography>
                    </Box>

                    {/* {chartLine('#22D3EE')} */}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* Content Performance */}
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <Typography fontSize="20px"><img src={textFileIcon} alt="text-file" /></Typography>
            <Typography fontWeight={700} fontSize="18px">
              Content Performance
            </Typography>
          </Stack>

          <Typography color="#D9D9D9" fontSize="13px" mb={2.5}>
            Overview of the content you've created and published.
          </Typography>

          <Grid container spacing={2}>
            {contentCards.map((card) => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} key={card.title}>
                <Card
                  sx={{
                    bgcolor: 'rgba(10,16,30,0.95)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '20px',
                    color: '#fff',
                    height: '100%',
                  }}
                >
                  <CardContent sx={{ p: 2.5 }}>
                    <Stack direction="row" spacing={1.2} alignItems="center" mb={2}>
                      <Box
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: '50px',
                          bgcolor: `${card.color}22`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '18px',
                        }}
                      >
                        {card.icon}
                      </Box>

                      <Typography fontSize="13px" fontWeight={600}>
                        {card.title}
                      </Typography>
                    </Stack>

                    <Typography fontSize="38px" fontWeight={700} lineHeight={1} mb={2}>
                      {card.value}
                    </Typography>

                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: '12px',
                          fontWeight: 600,
                        }}
                      >
                        <Box component="span" sx={{ color: card.growth >= 0 ? '#4ADE80' : '#FF0000' }}>
                          {card.growth}%
                        </Box>{' '}

                        <Box component="span" sx={{ color: '#D9D9D9' }}>
                          {card.vs}
                        </Box>
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Footer Banner */}
          <Card
            sx={{
              mt: 3,
              bgcolor: 'rgba(10,16,30,0.95)',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: '20px',
              color: '#fff',
              overflow: 'hidden',
            }}
          >
            <CardContent
              sx={{
                p: 2.5,
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                // justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'center' },
                gap: 2,
              }}
            >
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: '10px',
                  bgcolor: 'rgba(0, 0, 139, 0.22)', // transparent dark blue
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                }}
              >
                <AutoAwesomeIcon />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography fontSize="16px" fontWeight={700} mb={0.5}>
                  Great job! Your content is getting discovered and converting.
                </Typography>

                <Typography color="#8D97AB" fontSize="13px">
                  You captured 25% more leads and made 32% more revenue compared to last week.
                </Typography>
              </Box>

              {/* <Button sx={{ border: '1px solid #4BA5EB', borderRadius: '10px' }}>View Detailed Insights</Button> */}
              <Button
                sx={{
                  ml: { md: 'auto' },
                  border: '1px solid #4BA5EB',
                  borderRadius: '5px',
                  color: '#4BA5EB',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  gap: '2px',
                  alignItems: 'center'
                }}
              >
                <EqualizerIcon sx={{ color: '#4BA5EB' }} />
                View Detailed Insights
              </Button>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
